// 适用于新活动数据传参格式
import {
  conditionValue,
  getTaskTypeOptions,
} from "@/views/interactiveMarketing/activity/components/taskCommonField/index.js";
export const useInputTaskData = (list, actType = 0) => {
  const taskList = list.map((item) => {
    const taskObj = {
      activityType:
        item.type == 8 ||
        item.type == 12 ||
        item.type == 7 ||
        (item.type == 16 && item.activityType == 2) ||
        (actType == 86 && item.type == 4)
          ? 2
          : 1,
      taskType: item.type,
      taskValidity: item.taskTime,
      taskName: item.taskName,
      taskDesc: item.taskDesc,
    };
    if (item.id) {
      taskObj.id = item.id;
    }
    // 指定时间
    if (item.taskTime == 2) {
      taskObj.startTime = item.startTime;
      taskObj.endTime = item.endTime;
    }
    // 商品
    if (item.skuIds.length) {
      if (item.type == 17) {
        taskObj.skuIds = [];
      } else {
        taskObj.skuIds = item.skuIds.join(",");
      }
    }
    if (item.type == 18) {
      taskObj.activityType = 2;
      taskObj.inviteLimit = item.condition;
      taskObj.taskDoLimit = item.condition2;
    }
    // 浏览会场-跳转链接
    if (item.type == 5) {
      taskObj.jumpUrl = item.jumpUrl;
      taskObj.viewTime = item.viewTime;
      taskObj.giveLimit = item.giveLimit;
    }
    // 好友助力-邀请人数上限
    if (item.type == 8) {
      taskObj.inviteLimit = item.inviteLimit;
    }
    if (item.type == 17) {
      taskObj.activityType = 2;
      taskObj.orderCountType = item.orderCountType;
      taskObj.orderType = item.orderType;
      taskObj.skuType = item.skuType;
      // 指定商品规则提交，老数据无该字段时默认整单计算
      taskObj.statsSkuType = item.statsSkuType || 0;
      taskObj.itemTotalLimit = item.itemTotalLimit;
      taskObj.amtLimit = item.amtLimit;
      taskObj.orderStartTime = item.orderStartTime;
      taskObj.orderEndTime = item.orderEndTime;

      taskObj.giveType = item.giveType;
      taskObj.countType = item.countType;
      taskObj.taskDoType = item.taskDoType;
      if(item.giveType == 0){
        taskObj.taskDoType = 1
      }
      taskObj.venderIds = item.venderIds;
      taskObj.stepList = item.stepList;
      taskObj.venderIds = item.venderIds.join(",");
      taskObj.sellerSkuList = item.sellerSkuList.map((item) => {
        return {
          skuIds: item.skuIds,
          venderId: item.venderId,
        };
      });
      taskObj.orderPaymentType = item.orderPaymentType;
      taskObj.mergeOrder = item.mergeOrder|| false;
    }
    if (item.type == 20) {
      taskObj.activityType = 2;
      taskObj.skuType = item.skuType;
      // 指定商品规则提交，老数据无该字段时默认整单计算
      taskObj.statsSkuType = item.statsSkuType || 0;
      taskObj.orderStartTime = item.orderStartTime;
      taskObj.orderEndTime = item.orderEndTime;
      taskObj.countType = item.countType;
      taskObj.stepList = item.stepList;
      taskObj.giveType = 1;
      taskObj.taskDoType = 1;
    }
    // 任务门槛上限
    if (conditionValue.includes(item.type)) {
      if (item.type == 12 || item.type == 16) {
        taskObj.giveLimit = item.condition;
        taskObj.taskDoLimit = item.condition2;
      } else if (item.type == 4) {
        // 加购商品
        taskObj.addCartLimit = item.condition;
        if (actType == 86) {
          taskObj.taskDoLimit = item.condition2;
          taskObj.giveNum = item.giveNum;
        }
      } else if (item.type == 17) {
        taskObj.giveLimit = 1;
        if((item.giveType == 0&&item.orderCountType == 0) || ((item.giveType == 1 || item.giveType == 2)&&item.taskDoType == 1)) {
          taskObj.taskDoLimit = item.condition2
        }else {
          taskObj.taskDoLimit = 1
        }
      } else if (item.type == 20) {
        taskObj.taskDoLimit = item.condition2;
      } else {
        taskObj.giveLimit = item.condition;
      }
    }
    if (item.type == 7) {
      taskObj.giveLimit = item.giveLimit;
    }
    if (item.type == 23) {
      taskObj.activityType = 1;
      taskObj.giveLimit = 1;
      taskObj.searchKeyword = item.searchKeyword;
    }
    return taskObj;
  });
  return taskList;
};
export const useOutputTaskData = (list, that, actType = 0) => {
  const taskTypeOptions = getTaskTypeOptions(that.mainText, false, that.unit);
  const taskList = list.map((item) => {
    const obj = {
      id: item.id,
      type: item.taskType,
      taskTime: item.taskValidity,
      condition: null,
      condition2: null,
      count: null,
      endTime: null,
      startTime: null,
      skuIds: [],
      inviteLimit: null,
      jumpUrl: null,
      selectGoodsSkuList: [],
      activityType:
        item.taskType == 16 || item.taskType == 17 || item.taskType == 7
          ? item.activityType
          : 1,
      skuType: 0,
      statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
      orderType: 0,
      orderCountType: 1,
      itemTotalLimit: null,
      amtLimit: null,
      orderEndTime: null,
      orderStartTime: null,
      taskName: item.taskName,
      taskDesc: item.taskDesc,
      orderPaymentType: 1,
      mergeOrder: false,
    };
    // 指定时间
    if (item.taskValidity == 2) {
      obj.startTime = item.startTime;
      obj.endTime = item.endTime;
    }
    // 商品
    if (item.skuIds) {
      obj.skuIds = item.skuIds.split(",");
    }
    if (item.itemList && item.itemList.length) {
      obj.selectGoodsSkuList = item.itemList.map((item) => {
        return {
          skuName: item.title,
          jdPrice: item.price,
          ...item,
        };
      });
    }
    // 浏览会场-跳转链接
    if (item.taskType == 5) {
      obj.jumpUrl = item.jumpUrl;
      obj.viewTime = item.viewTime || 1;
      obj.giveLimit = item.giveLimit || 1;
    }
    // 好友助力-邀请人数上限
    if (item.taskType == 8) {
      obj.inviteLimit = item.inviteLimit;
    }
    if (item.taskType == 17) {
      obj.orderCountType = item.orderCountType;
      obj.orderType = item.orderType;
      obj.skuType = item.skuType;
      // 指定商品规则回显，老数据无该字段时默认整单计算
      obj.statsSkuType = item.statsSkuType || 0;
      obj.itemTotalLimit = item.itemTotalLimit;
      obj.amtLimit = item.amtLimit;
      obj.orderStartTime = item.orderStartTime;
      obj.orderEndTime = item.orderEndTime;
      obj.giveType = item.giveType;
      obj.countType = item.countType;
      obj.taskDoType = item.taskDoType;
      if (obj.giveType == 0) {
        obj.taskDoType = 1;
      }
      that.taskLevelList = item.stepList;
      obj.venderIds = item.venderIds
        ? item.venderIds.split(",").map((item) => +item)
        : [that.$store.getters.loginUserInfo.venderId];
      obj.sellerSkuList =
        item.sellerSkuList && item.sellerSkuList.length
          ? item.sellerSkuList
          : [
              {
                skuIds: item.skuIds ? item.skuIds.split(",") : [],
                venderId: that.$store.getters.loginUserInfo.venderId,
                itemList: [],
              },
            ];
      if (that.activityData.isCopy||that.isDraftEdit) {
        // 跨店复制
        if(obj.venderIds.length>0) {
          let index = obj.venderIds.findIndex((item)=>{
            return item == that.$store.getters.loginUserInfo.venderId
          })
          if(index==-1) {
            obj.venderIds.unshift(Number(that.$store.getters.loginUserInfo.venderId))
            obj.sellerSkuList.unshift({
              venderId: Number(that.$store.getters.loginUserInfo.venderId),
              skuIds: [],
              itemList: [],
            })
          }
        }
      } 
      obj.selectGoodsSkuList = item.itemList;
      obj.stepList = item.stepList;
      obj.orderPaymentType = item.orderPaymentType===null?1:item.orderPaymentType;
      obj.mergeOrder = item.mergeOrder|| false;
    }
    if (item.taskType == 20) {
      obj.skuType = item.skuType;
      // 指定商品规则回显，老数据无该字段时默认整单计算
      obj.statsSkuType = item.statsSkuType || 0;
      obj.orderStartTime = item.orderStartTime;
      obj.orderEndTime = item.orderEndTime;
      obj.countType = item.countType;
      that.taskOrderList =
        item.stepList && item.stepList.length > 0 ? item.stepList : [];
      that.hasSelectGoods = item.itemList || [];
      obj.selectGoodsSkuList = item.itemList;
      obj.stepList = item.stepList;
    }
    if (item.taskType == 18) {
      obj.condition = item.inviteLimit;
      obj.condition2 = item.taskDoLimit;
    }
    if (item.taskType == 23) {
      obj.searchKeyword = item.searchKeyword;
    }
    // 任务门槛上限
    const taskTypeObj = taskTypeOptions.find(
      (option) => option.value == item.taskType
    );
    if (conditionValue.includes(item.taskType)) {
      if (item.taskType == 12) {
        obj.condition = item.giveLimit;
        obj.condition2 = item.taskDoLimit;
      } else if (item.taskType == 4) {
        obj.condition = item.addCartLimit;
        obj.count = taskTypeObj.taskCount;
        if (actType == 86) {
          obj.condition2 = item.taskDoLimit;
          obj.giveNum = item.giveNum;
        }
      } else if (item.taskType == 16) {
        obj.condition = item.giveLimit;
        obj.condition2 = item.taskDoLimit;
        obj.activityType = item.activityType;
      } else if (item.taskType == 17) {
        obj.activityType = 2;
        obj.condition = item.giveLimit;
        obj.condition2 = item.taskDoLimit;
        obj.count = taskTypeObj.taskCount;
      } else if (item.taskType == 20) {
        obj.activityType = 2;
        obj.condition2 = item.taskDoLimit;
      } else {
        obj.condition = item.giveLimit;
        obj.count = taskTypeObj.taskCount;
      }
    } else {
      obj.condition = taskTypeObj.taskCondition;
      obj.count = taskTypeObj.taskCount;
    }
    if (item.taskType == 7) {
      obj.giveLimit = item.giveLimit;
    }
    return obj;
  });
  return taskList;
};

export const useCondition = (item, that, ...args) => {
  const { type, condition, orderCountType } = item;
  const [isShowCustom = false, unit, mainText] = args;
  let str = condition;
  if (isShowCustom && item.taskDesc) {
    str = item.taskDesc;
  } else {
    if (type == 13) {
      str = `成功浏览${condition}件商品，赠送1${unit}${mainText}`;
    } else if (type == 4) {
      str = `成功加购${condition}件商品，赠送1${unit}${mainText}`;
    } else if (type == 9) {
      str = `成功分享${condition}次商品，赠送1${unit}${mainText}`;
    } else if (type == 10) {
      str = `成功分享${condition}次店铺，赠送1${unit}${mainText}`;
    } else if (type == 11) {
      str = `成功分享${condition}次活动，赠送1${unit}${mainText}`;
    } else if (type == 12) {
      str = `每成功预约${condition}件商品，赠送1${unit}${mainText}`;
    } else if (type == 16) {
      str = `每${condition}积分可兑换1${unit}${mainText}`;
    } else if (type == 17) {
      if (item.giveType == 0) {
        str =
          orderCountType == 0
            ? `每1个订单赠送1${unit}${mainText}`
            : `完成任务赠送1${unit}${mainText}`;
      } else if (item.giveType == 1) {
        that.taskLevelList.forEach((it) => {
          str = `购买商品，每满${
            item.countType == 1
              ? it.limit + "元"
              : item.countType == 2
              ? it.limit + "件"
              : item.countType == 3
              ? it.limit + "笔"
              : ""
          }可赠送${it.giveNum}${unit}${mainText}`;
        });
      } else if (item.giveType == 2) {
        str = `购买商品：`;
        that.taskLevelList.forEach((it) => {
          str =
            str +
            `\n满${
              item.countType == 1
                ? it.limit + "元"
                : item.countType == 2
                ? it.limit + "件"
                : item.countType == 3
                ? it.limit + "笔"
                : ""
            }可赠送${it.giveNum}${unit}${mainText}；`;
        });
      }
    } else if (type == 18) {
      str = `成功邀请好友入会${condition}次，赠送1${unit}${mainText}`;
    } else if (type == 20) {
      that.taskOrderList.forEach((it) => {
        str = `成功下单并支付定金，每满${
          item.countType == 2 ? it.limit + "件" : it.limit + "笔"
        }可赠送${it.giveNum}${unit}${mainText}`;
      });
    } else if (type == 5) {
      str = `成功浏览会场${item.viewTime || 1}秒，赠送${
        item.giveLimit || 1
      }${unit}${mainText}`;
    } else if (type == 23) {
      str = `成功查询关键词，赠送1${unit}${mainText}`;
    }
  }
  return str;
};
